import useVaultCollections from './useVaultCollections';
import { useQuery } from '@tanstack/react-query';
import { addressEqual } from 'nftx.js';
import { QueryKey } from '../../queryKeys';

const useVaultCollection = (addressOrSlug: string | undefined) => {
  const { data: collections } = useVaultCollections();

  return useQuery(
    [QueryKey.VAULT_COLLECTION, addressOrSlug],
    () => {
      return collections?.find(
        (c) =>
          addressEqual(c.collectionAddress, addressOrSlug) ||
          addressOrSlug?.toLowerCase() === c.slug.toLowerCase()
      );
    },
    {
      enabled: Boolean(collections?.length && addressOrSlug),
    }
  );
};

export default useVaultCollection;
